import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import { useLanguage } from '../../../hooks/useLanguage';
import ScrollToTop from '../../../components/Common/ScrollToTop';

const MyAppLayout = () => {
  const { direction, fontFamily } = useLanguage();
  const location = useLocation();
  
  // Masquer le header sur la page POS
  const isPosPage = location.pathname.includes('/pos');

  return (
    <div className={`min-h-screen flex flex-col ${fontFamily}`} dir={direction}>
      {!isPosPage && <Header />}
      <main className={`flex-grow ${isPosPage ? '' : 'p-6'}`}>
        <Outlet />
      </main>
      <ScrollToTop />
    </div>
  );
};

export default MyAppLayout; 